import React from 'react';
import clsx from 'clsx';
import { TooltipReact } from 'common/components/tooltip';
import styles from './index.module.styl';
export type EventIndicatorProps = {
  played?: boolean;
  isObserved?: boolean;
  tooltipText: string;
  isHovered?: boolean;
};
export function EventIndicator(props: EventIndicatorProps) {
  return <div className={clsx(styles.eventIndicator, {
    [styles.played]: props.played,
    [styles.observed]: props.isObserved,
    [styles.isHovered]: props.isHovered
  })} data-sentry-component="EventIndicator" data-sentry-source-file="index.tsx">
      <TooltipReact data-sentry-element="TooltipReact" data-sentry-source-file="index.tsx">{props.tooltipText}</TooltipReact>
    </div>;
}